import { TargetType, TextTarget, FixedTarget } from './OnboardingContext.type';

// Type Guards
export function isATextTarget(target: TargetType): target is TextTarget {
    return (
        (target as TextTarget).parent !== undefined &&
        (target as TextTarget).text !== undefined
    );
}

export const isAPositionTarget = (
    target: TargetType | undefined,
): target is FixedTarget => {
    return ['pluginSync', 'pluginDrag', 'pluginGeneralSetting'].includes(
        target as FixedTarget,
    );
};
